import ROUTES_CONFIG from "./routes";

export { ROUTES_CONFIG };
